export {
    UPDATE_DEVICE_CONFIG_CONTAINERS,
    UPDATE_DEVICE_CONFIG_CONTAINER_FIELDS,
} from './NewDeviceFormComponents/configFields'

export const EDIT_PERMISSION_WILDCARD = '*'

export const UPDATE_DEVICE_SECTIONS = {
    main: 'main',
    market: 'market',
    paymentProviders: 'paymentProviders',
    config: 'config',
}

export const UPDATE_DEVICE_EDIT_PERMISSION_TIERS = {
    full: {
        sections: {
            [EDIT_PERMISSION_WILDCARD]: {
                fields: [EDIT_PERMISSION_WILDCARD],
            },
        },
    },
    limited: {
        sections: {
            [UPDATE_DEVICE_SECTIONS.main]: {
                fields: ['version_id', 'version_label', 'fbox_version', 'disconnect_reason'],
            },
            [UPDATE_DEVICE_SECTIONS.paymentProviders]: {
                fields: [EDIT_PERMISSION_WILDCARD],
            },
            [UPDATE_DEVICE_SECTIONS.config]: {
                containers: {
                    storeAndHardware: {
                        fields: ['factory_id'],
                    },
                    flags: {
                        fields: [EDIT_PERMISSION_WILDCARD],
                    },
                }
            },
        },
    },
}
